module.exports = __webpack_public_path__ + "static/media/upload-file.b1ffb865.gif";